import { Box, Icon, Text, Touchable } from '@factorialco/deprecated-design-system'
import { getIn } from 'formik'
import { useToggle } from 'usehooks-ts'

import TextArea from 'modules/core/components/TextArea'
import { useFormContext } from 'modules/core/hooks/useForm'
import i18n from 'modules/core/lib/i18n'

import { RatingSelector } from 'modules/ats/components/Feedbacks/RatingSelector'
import { IQuestion } from 'modules/ats/lib/utils/evaluationForms'

import { AtsEvaluationFormValues } from './forms'

interface Props {
  question: IQuestion
}

export const AnswerItem = ({ question }: Props) => {
  const form = useFormContext<AtsEvaluationFormValues>()
  const fieldName = `evaluationFormAnswers.${question.id}`
  const answer = getIn(form.values, fieldName)
  const [showEditor, setShowEditor] = useToggle(!!answer?.note)

  return (
    <Box padding="s16" gap="s16">
      <Box gap="s8">
        <Box gap="s2" justifyContent="spaceBetween" flexDirection="row" alignItems="center">
          <Text.Normal color="grey1000" weight="medium">
            {question.text}
          </Text.Normal>
          <Touchable onClick={setShowEditor}>
            <Box flexDirection="row" alignItems="center">
              <Icon.Small icon="add" color="viridian1200" />
              <Text.Normal weight="medium" color="viridian1200" size="200">
                {i18n.t('ats.application_details.evaluations.add_evaluation')}
              </Text.Normal>
            </Box>
          </Touchable>
        </Box>
        <Text.Normal color="grey800">{question.description} </Text.Normal>
      </Box>
      <RatingSelector
        value={answer?.score}
        onChange={(newRating) => form.setFieldValue(`${fieldName}.score`, newRating)}
      />
      {showEditor && (
        <TextArea
          placeholder={i18n.t('ats.application_details.evaluations.evaluation_placeholder')}
          value={answer?.note}
          onChange={(note) => form.setFieldValue(`${fieldName}.note`, note)}
        />
      )}
    </Box>
  )
}
